import React from 'react';

const items = [
  'Accounting', 'Taxation', 'GST Compliance', 'Auditing', 'Financial Planning',
  'Business Registration', 'Payroll', 'Advisory', 'Bookkeeping', 'Tax Savings',
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <section className="relative py-10 border-y border-white/5 bg-ink-800 overflow-hidden" data-testid="marquee">
      <div className="marquee-track">
        {row.map((it, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display italic text-2xl sm:text-3xl text-slate-500 px-8">{it}</span>
            <span className="w-1.5 h-1.5 rounded-full bg-gold" />
          </span>
        ))}
      </div>
      <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-ink-800 to-transparent pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-ink-800 to-transparent pointer-events-none" />
    </section>
  );
}
